export default __webpack_public_path__ + "static/media/logo.446ecdd8.svg";